import {
  Users,
  FileText,
  LayoutDashboard,
  UserCircle,
  SquareKanban,
  type LucideIcon,
} from 'lucide-react';

const isStaging = import.meta.env.MODE === 'staging';

export interface AppConfig {
  id: string;
  /** Funnel position badge. Omit for standalone tools that are not a funnel step. */
  step?: string;
  name: string;
  subtitle: string;
  description: string;
  icon: LucideIcon;
  accent: string;
  accentGlow: string;
  url: string;
}

export const apps: AppConfig[] = [
  {
    id: 'crm',
    step: '01',
    name: 'CRM אלקה',
    subtitle: 'ניהול לקוחות',
    description: 'ניהול לקוחות, אנשי קשר, עסקאות ומשימות',
    icon: Users,
    accent: '#8b5cf6',
    accentGlow: 'rgba(139, 92, 246, 0.4)',
    url: isStaging ? 'https://elka-crm-stg.web.app' : 'https://crm.elka-hashmal.co.il',
  },
  {
    id: 'quotes',
    step: '02',
    name: 'הצעות מחיר',
    subtitle: 'תמחור והצעות',
    description: 'תמחור, הצעות מחיר, מכרזים וניהול ספקים',
    icon: FileText,
    accent: '#f59e0b',
    accentGlow: 'rgba(245, 158, 11, 0.4)',
    url: isStaging ? 'https://elka-quote-stg.web.app' : 'https://quotes.elka-hashmal.co.il',
  },
  {
    id: 'manager',
    step: '03',
    name: 'ניהול אלקה',
    subtitle: 'פרויקטים והזמנות',
    description: 'ניהול פרויקטים, הזמנות, רכש ולוח עבודה',
    icon: LayoutDashboard,
    accent: '#06b6d4',
    accentGlow: 'rgba(6, 182, 212, 0.4)',
    url: isStaging ? 'https://elka-manager-stg.web.app' : 'https://app.elka-hashmal.co.il',
  },
  {
    id: 'team',
    step: '04',
    name: 'פורטל עובדים',
    subtitle: 'צוות ומשאבים',
    description: 'תלושי שכר, חופשות, דיווח שעות ויומן עבודה',
    icon: UserCircle,
    accent: '#10b981',
    accentGlow: 'rgba(16, 185, 129, 0.4)',
    url: isStaging ? 'https://elka-team-stg.web.app' : 'https://team.elka-hashmal.co.il',
  },
];

// Standalone tools: shown below the funnel, they are not a step of client → project.
export const tools: AppConfig[] = [
  {
    id: 'tasks',
    name: 'לוח משימות',
    subtitle: 'משימות ופרויקטים',
    description: 'לוח משימות ופרויקטים לצוות המשרד',
    icon: SquareKanban,
    accent: '#6366f1',
    accentGlow: 'rgba(99, 102, 241, 0.4)',
    url: isStaging ? 'https://elka-tasks-stg.web.app' : 'https://tasks.elka-hashmal.co.il',
  },
];
